import type { UseCaseConfig, UseCaseId } from '../types'
import { adaptationPlanning } from './adaptation-planning'
import { assetAndInfrastructurePlanning } from './asset-and-infrastructure-planning'
import { emergencyPlanningAndBusinessContinuity } from './emergency-planning-and-business-continuity'
import { landUsePlanningAndDevelopment } from './land-use-planning-and-development'

export const USE_CASES: UseCaseConfig[] = [
  adaptationPlanning,
  landUsePlanningAndDevelopment,
  emergencyPlanningAndBusinessContinuity,
  assetAndInfrastructurePlanning,
]

export const USE_CASES_MAP = Object.fromEntries(USE_CASES.map((uc) => [uc.id, uc])) as Record<
  UseCaseId,
  UseCaseConfig
>
